import { useState } from "react";
import Select from 'react-select';
import { ScanPage } from "../Pages/ScanPage";

import axios from "axios";
import '../home.scss';
import Base from './Baseurl.json';
export const MealForm = () => {
    var today = new Date();
    var Month = '';
    if ((today.getMonth() + 1) < 10) {
        Month = "0" + (today.getMonth() + 1)
    } else {
        Month = '' + (today.getMonth() + 1)
    }

    var token = document.cookie
    var nowdate = today.getFullYear() + "-" + Month + "-" + today.getDate();
    const [genre, setGenre] = useState("");
    const [gram, setgram] = useState(0);
    const [imageurl, setImageurl] = useState("https://1.bp.blogspot.com/-ezrLFVDoMhg/Xlyf7yQWzaI/AAAAAAABXrA/utIBXYJDiPYJ4hMzRXrZSHrcZ11sW2PiACNcBGAsYHQ/s1600/no_image_yoko.jpg");
    const [limit, setLimit] = useState(nowdate);

    const headers = {
        "jwt-token": "Bearer " + token
    }

    const PushData = async () => {
        const genreurl = encodeURI(genre)
        const imageurl2 = encodeURI(imageurl)
        const limiturl = encodeURI(limit)

        const url = Base.Baseurl + "/api/v1/foods?name=" + genreurl + "&quantity=" + gram + "&limit_at=" + limiturl + "&thumbnail_url=" + imageurl2;
        console.log(url);

        await axios.post(url, {}, { headers })
            .catch(err => {
                return null;
            })
    }

    const imagelist = [
        { value: "https://1.bp.blogspot.com/-5ylpKyST62o/WtRy9bfvVYI/AAAAAAABLi8/YvXlJRE5bTI688Xua84VyrRkVEvlOPmUACLcBGAs/s400/food_niku_katamari_abura.png", label: '肉類' },
        { value: "https://2.bp.blogspot.com/-fDWhLpun4ow/VMIt5u_BU_I/AAAAAAAAqz8/YodooYXtNxQ/s400/sashimi_maguro_ootoro.png", label: '魚類' },
        { value: "https://3.bp.blogspot.com/-v3bUhbtBi1Y/UUFxxbikL-I/AAAAAAAAO1A/vqZw9bYuabY/s500/vegetable.png", label: '野菜類' }
    ]
    function Push() {
        if (genre === "" || imageurl === "https://1.bp.blogspot.com/-ezrLFVDoMhg/Xlyf7yQWzaI/AAAAAAABXrA/utIBXYJDiPYJ4hMzRXrZSHrcZ11sW2PiACNcBGAsYHQ/s1600/no_image_yoko.jpg" || gram === 0) {
            console.log("error")
        } else {
            PushData()
        }
    }

    return (
        <div>
            <label>ジャンル:</label>
            <input className="w=1/3 py-2border-b focus:outline-none focus:border-b-2 focus:border-indigo-500 placeholder-gray-500 placeholder-opacity-50"
                type="text"
                value={genre}
                placeholder="ジャンル名を入力"
                onChange={event => setGenre(event.target.value)}
            /><br></br>

            <label>イメージ画像</label><br></br>

            <img src={imageurl} alt="img"
            style={{
                margin: "auto",
                width: "50%",}}
            width="146" height="146" ></img>
            <Select
                options={imagelist}
                onChange={(result) => { setImageurl(result?.value || "") }}
            />
            <br></br>
            <label>量:</label>
            <input className="w=1/3 py-2border-b focus:outline-none focus:border-b-2 focus:border-indigo-500 placeholder-gray-500 placeholder-opacity-50"
                type="number"
                value={gram}
                placeholder="量(g)を入力"
                onChange={
                    (event: React.ChangeEvent<HTMLInputElement>) => {
                        const value: number = Number(event.target.value);
                        setgram(value);
                    }} />
            <br></br>

            賞味期限<br></br>
            <input
                type="date"
                value={limit}
                onChange={event => setLimit(event.target.value)}
            ></input><br></br>
            <button className="shadow-lg bg-rose-500 shadow-rose-500/50 text-white rounded px-2 py-1"
                onClick={() => {
                    Push();
                    ScanPage(
                    );
                }}
            >
                送信
            </button>
        </div>
    )
}